export interface ModalState {
  readonly message: string
  readonly shown: boolean
}

abstract class ShownModalState implements ModalState {
  abstract readonly message: string
  readonly shown = true
}

export class NoError implements ModalState {
  readonly message = ''
  readonly shown = false
}

export class LoginError extends ShownModalState {
  readonly message = 'ログインできませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
}

export class UserNotFetchedError extends ShownModalState {
  readonly message = 'お客様情報が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
}

export class OrderHistoryNotFetchedError extends ShownModalState {
  readonly message = '購入履歴が取得できませんでした。<br/>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。'
}

export class CannotReorderDuringOrderRegistrationError extends ShownModalState {
  readonly message = 'ご注文情報登録中は再注文できません'
}

export class AlreadyCanceledError extends ShownModalState {
  readonly message = 'この注文はすでにキャンセルされています。'
}

export class AddressNotFetchedError extends ShownModalState {
  readonly message = '住所が取得できませんでした'
}
